import React from 'react';
import { CircleNotch, Copy, FileArrowUp, Plus, Upload } from '@phosphor-icons/react';
import { Button } from '../../components/ui/button';
import DataQualityBadge from '../../components/shared/DataQualityBadge';

export const PatientsPageHeader = ({
  scanningDuplicates,
  onScanDuplicates,
  onImport,
  onBulkUpload,
  onAddPatient,
}) => (
  <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
    <div className="flex items-center gap-3">
      <div>
        <h1 className="text-2xl font-bold text-slate-900" style={{ fontFamily: 'Manrope' }}>Patients</h1>
        <p className="text-slate-500">Manage your patient roster</p>
      </div>
      <DataQualityBadge />
    </div>
    <div className="flex gap-2 flex-wrap">
      <Button
        variant="outline"
        size="sm"
        onClick={onScanDuplicates}
        disabled={scanningDuplicates}
        data-testid="scan-duplicates-btn"
      >
        {scanningDuplicates
          ? <CircleNotch size={16} className="mr-1 animate-spin" />
          : <Copy size={16} className="mr-1" />}
        Find Duplicates
      </Button>
      <Button variant="outline" onClick={onImport} data-testid="import-patients-btn">
        <Upload size={18} className="mr-2" /> Import (legacy)
      </Button>
      <Button
        variant="outline"
        onClick={onBulkUpload}
        data-testid="bulk-upload-patients-btn"
      >
        <FileArrowUp size={18} className="mr-2" /> Bulk Import (CSV/PDF)
      </Button>
      <Button
        onClick={onAddPatient}
        className="bg-indigo-900 hover:bg-indigo-800"
        data-testid="add-patient-btn"
      >
        <Plus size={18} className="mr-2" /> Add Patient
      </Button>
    </div>
  </div>
);

export default PatientsPageHeader;
